import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

/**
 * Bronson TileSelectGroup component.
 *
 * @param {string} [className] - Additional classes for the {@link TileSelectGroup} element.
 * @param {string} [testId] - The `testId` string.
 * @param {string} [layoutItemClassName] - Additional classes which determines the width of the layout item.
 * @param {React.ReactNode} [children] - Children to be rendered inside the {@link TileSelectGroup} element.
 * @param {object} [otherProps] - Other props to pass on the {@link TileSelectGroup} element.
 * @return {JSX.Element} - The {@link TileSelectGroup} element.
 * @constructor
 */
export function TileSelectGroup({ className, testId, layoutItemClassName, children, ...otherProps }) {
  function renderChildren() {
    return React.Children.map(children, (child) => {
      if (!child) {
        return null
      }

      const layoutItemClassNameList = classNames('o-layout__item', layoutItemClassName).trim()

      return <div className={layoutItemClassNameList}>{child}</div>
    })
  }

  const classNameList = classNames('o-layout', 'o-layout--equal-height', className).trim()

  return (
    <div {...otherProps} data-testid={testId} className={classNameList}>
      {renderChildren()}
    </div>
  )
}

TileSelectGroup.propTypes = {
  className: PropTypes.string, // Custom CSS classes.
  testId: PropTypes.string, // Added for `[data-testid]` attribute.
  layoutItemClassName: PropTypes.string, // Bronson template: 'layout-modifier'.
  children: PropTypes.node, // Bronson template: 'tile-select'. Use 'TileSelectGroup.TileSelect' component.
}
